"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElement = void 0;
var getElement = function (element) {
    return element && 'current' in element ? element === null || element === void 0 ? void 0 : element.current : element;
};
exports.getElement = getElement;
